var _path, _path2, _ellipse, _path3, _path4, _rect, _rect2, _rect3, _ellipse2, _rect4, _rect5, _rect6, _ellipse3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoApps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.597 263C207.978 263 259.359 212.184 259.359 149.5C259.359 86.8157 207.978 36 144.597 36C81.2156 36 29.835 86.8157 29.835 149.5C29.835 212.184 81.2156 263 144.597 263Z",
    fill: "url(#paint0_linear_1414_782)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.613 221.852C244.658 221.483 245.759 220.993 246.608 220.284C247.616 219.442 248.025 218.357 248.301 217.215C248.654 215.748 248.795 214.185 249.224 212.716C249.383 212.17 249.688 211.964 249.819 211.872C250.15 211.641 250.485 211.579 250.8 211.602C251.173 211.629 251.686 211.769 252.023 212.388C252.071 212.476 252.134 212.611 252.176 212.796C252.206 212.932 252.226 213.355 252.259 213.53C252.34 213.96 252.408 214.391 252.471 214.824C252.684 216.264 252.806 217.487 253.476 218.81C254.385 220.607 255.296 221.706 256.532 222.193C257.727 222.664 259.156 222.575 260.981 222.206C261.155 222.164 261.327 222.129 261.497 222.099C262.301 221.96 263.071 222.483 263.229 223.276C263.387 224.068 262.875 224.84 262.078 225.015C261.911 225.051 261.747 225.085 261.585 225.117C259.118 225.721 256.263 227.876 254.603 229.764C254.092 230.345 253.343 231.972 252.579 233.01C252.015 233.776 251.382 234.281 250.85 234.459C250.493 234.579 250.193 234.561 249.945 234.5C249.584 234.412 249.285 234.219 249.055 233.911C248.93 233.743 248.814 233.518 248.759 233.23C248.732 233.092 248.729 232.74 248.73 232.581C248.574 232.051 248.384 231.534 248.245 230.999C247.914 229.724 247.264 228.917 246.492 227.851C245.77 226.853 244.995 226.225 243.858 225.725C243.711 225.689 242.517 225.4 242.096 225.235C241.481 224.991 241.187 224.584 241.081 224.365C240.9 223.993 240.881 223.668 240.917 223.397C240.971 222.996 241.153 222.654 241.475 222.378C241.674 222.206 241.972 222.039 242.371 221.957C242.68 221.894 243.498 221.857 243.613 221.852ZM250.612 219.773C250.667 219.895 250.726 220.018 250.788 220.141C252.12 222.772 253.61 224.241 255.42 224.954L255.481 224.977C254.27 225.866 253.173 226.86 252.335 227.813C251.99 228.206 251.534 229.02 251.04 229.856C250.592 228.415 249.859 227.396 248.937 226.121C248.232 225.148 247.494 224.415 246.587 223.819C247.291 223.461 247.962 223.043 248.547 222.554C249.521 221.74 250.165 220.798 250.612 219.773Z",
    fill: "#E3E3E3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4352,
    cy: 127.383,
    rx: 5.43521,
    ry: 5.37545,
    fill: "#E3E3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4331 79.213C61.5975 79.7828 62.1988 80.1107 62.7741 79.9442L61.4331 79.213ZM61.4331 79.213L60.9533 79.3537C59.5764 74.6584 56.8728 70.9972 52.7201 68.3468L52.7199 68.3467M61.4331 79.213L60.9527 79.3516C61.1949 80.1912 62.0768 80.6665 62.9131 80.4244L62.9138 80.4243C63.7459 80.1822 64.2375 79.3087 63.9891 78.4688C62.394 73.0305 59.2404 68.7671 54.4263 65.6931L52.7199 68.3467M52.7199 68.3467C51.9866 67.8782 51.7687 66.9022 52.2445 66.1679M52.7199 68.3467L52.2445 66.1679M52.2445 66.1679C52.7149 65.4353 53.6942 65.2254 54.4262 65.6931L52.2445 66.1679Z",
    fill: "black",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.254 81.0127L112.253 81.0128C110.993 81.6489 109.918 81.6069 109.059 81.1814C108.24 80.7765 107.642 80.0029 107.278 79.043L107.278 79.0428C106.931 78.127 106.793 77.0006 106.778 75.9363C106.765 74.9876 106.851 74.0552 106.994 73.3146C106.171 72.4923 105.275 71.7419 104.321 71.0692C96.7517 65.7336 85.5302 67.6406 76.798 75.7941C75.3429 77.1535 74.2309 79.2978 73.3862 81.9601C72.5442 84.6143 71.9833 87.7332 71.598 90.991L71.598 90.9911C70.5533 99.8143 70.9349 109.537 71.1152 114.131C71.1423 114.82 71.1648 115.394 71.1773 115.832L71.1774 115.833C71.1886 116.263 71.1742 116.611 71.1499 116.87C71.1379 116.999 71.1231 117.11 71.107 117.199C71.0938 117.272 71.0733 117.371 71.0375 117.453C70.7438 118.145 70.1975 118.336 69.8575 118.4L69.8522 118.401C69.3721 118.486 68.9716 118.395 68.6488 118.228L68.6462 118.227C68.2057 117.996 67.8559 117.591 67.6988 117.009L67.6978 117.006C67.6144 116.687 67.5993 116.284 67.6081 115.906L67.6083 115.901C67.6109 115.825 67.6166 115.749 67.622 115.684C67.6232 115.669 67.6244 115.654 67.6255 115.64C67.6297 115.59 67.6333 115.546 67.636 115.502C67.6393 115.448 67.6402 115.407 67.6389 115.375C67.6375 115.342 67.6343 115.333 67.6356 115.337C67.3453 114.33 67.0031 113.343 66.6549 112.338C66.604 112.192 66.553 112.045 66.5021 111.897L66.5017 111.896C65.1853 108.057 63.4807 104.454 61.5791 100.84L62.0216 100.608L61.5791 100.84C61.0683 99.8698 60.5594 98.8955 60.0498 97.9198C54.4954 87.2859 48.8562 76.4896 39.8322 68.5204L39.8321 68.5203C39.1809 67.9448 39.1151 66.9471 39.6991 66.2943C40.2777 65.6426 41.2752 65.5879 41.9289 66.1606L41.9303 66.1618C51.3603 74.4874 57.2527 85.754 62.9511 96.6496C63.4282 97.5619 63.904 98.4716 64.3804 99.3767L64.3804 99.3768C65.5897 101.675 66.7274 103.981 67.7438 106.35C67.6958 100.974 67.8628 94.3178 68.7642 88.3173C69.2347 85.1839 69.9197 82.2169 70.8727 79.6702C71.824 77.1285 73.0546 74.9723 74.6361 73.4947L74.6362 73.4946C84.4315 64.348 97.3212 62.2722 106.148 68.4966L106.148 68.4967C106.912 69.0359 107.647 69.6195 108.344 70.2451C113.079 62.3641 122.716 59.2736 131.246 63.1472C132.043 63.508 132.393 64.4437 132.031 65.2356L132.031 65.2356L132.03 65.2386C131.663 66.0275 130.729 66.3748 129.934 66.0153L129.934 66.0151C122.632 62.6996 114.372 65.5689 110.631 72.62C111.403 73.5519 112.1 74.5497 112.701 75.6077C112.996 76.127 113.542 77.2697 113.629 78.2943C113.728 79.4154 113.338 80.4645 112.254 81.0127ZM110.237 77.929L110.237 77.9296C110.296 78.083 110.341 78.1895 110.389 78.2676C110.409 78.3011 110.426 78.3224 110.439 78.336C110.361 78.008 110.212 77.6673 110.08 77.4059C110.124 77.5922 110.176 77.7679 110.237 77.929Z",
    fill: "black",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.6317,
    y: 94.887,
    width: 197.556,
    height: 70.4335,
    rx: 24,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 173.181,
    y: 119.135,
    width: 66.6179,
    height: 9.23718,
    rx: 4.61859,
    fill: "#CCC6D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.861,
    y: 132.99,
    width: 131.274,
    height: 9.23718,
    rx: 4.61859,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.919,
    cy: 130.681,
    rx: 11.4858,
    ry: 11.5465,
    fill: "#E1DCEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.99994,
    y: 153.774,
    width: 197.556,
    height: 70.4335,
    rx: 24,
    fill: "#E1DCEB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58.389,
    y: 178.022,
    width: 66.6179,
    height: 9.23718,
    rx: 4.61859,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.389,
    y: 191.878,
    width: 131.274,
    height: 9.23719,
    rx: 4.61859,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7145,
    cy: 189.568,
    rx: 11.4858,
    ry: 11.5465,
    fill: "#CCC6D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1414_782",
    x1: 143.712,
    y1: -0.958387,
    x2: 146.012,
    y2: 397.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoApps);
export default __webpack_public_path__ + "static/media/NoApps.4a0ced7351b3696b5aae2b42bc4507ff.svg";
export { ForwardRef as ReactComponent };